/* eslint-disable no-param-reassign */
import { paginationSerializer } from './paginationSerializer'

// eslint-disable-next-line import/prefer-default-export
export const notificationsIndexSerializer = (data = {}) => {
  const newData = {
    meta: {},
    notifications: []
  }

  const { data: innerData = {}, pagination = {} } = data

  const { totalUnread, notifications = [] } = innerData

  newData.notifications = notifications.map((notification) => {
    const newNotification = {
      ...notification
    }

    return newNotification
  })

  newData.totalUnread = totalUnread
  newData.meta.pagination = paginationSerializer(pagination || data)

  return newData
}
